import * as bodyScrollLock from 'body-scroll-lock';

import globals from './globals';

export default {

	isDesktopLg() {
		return innerWidth <= 1440;
	},

	isDesktop() {
		return innerWidth > 1024;
	},

	isMobile() {
		return innerWidth <= 1024;
	},

	isIE() {
		return globals.$html.hasClass('is-browser-ie');
	},

	lockScroll(state, $element) {
		const element = $element ? $element.get(0) : null;

		if (state) {
			bodyScrollLock.disableBodyScroll(element, {
				reserveScrollBarGap: true,
			});

			setTimeout(() => {
				globals.$html.addClass('no-scroll');
			}, 0);
		} else {
			globals.$html.removeClass('no-scroll');

			bodyScrollLock.enableBodyScroll(element);
		}
	},

	scrollTo(position, duration = 500, $element = $('html, body')) {
		return new Promise((resolve) => {
			$element
				.stop()
				.animate({
					scrollTop: position,
				}, duration, 'swing', resolve);
		});
	},

	resize(name, callback) {
		if (innerWidth === globals.$window.data(`width-${name}`)) {
			return;
		}

		clearTimeout(globals.$window.data(`resize-${name}`));

		globals.$window.data({
			[`width-${name}`]: innerWidth,
			[`resize-${name}`]: setTimeout(callback, 500),
		});
	},

	clearText(text) {
		return text.toString().trim().replace(/\s+/, ' ');
	},

};
